module.exports = __webpack_public_path__ + "static/media/doctor_grey.70be15a7.svg";